import React from 'react'
import loadable from '@loadable/component'

import { Skeletons } from '@usap/widgets'

const { Fallback } = Skeletons

const RecentlyViewCard = loadable(
  () => import('../RecentViewedProduct/RecentlyViewCard'),
  { fallback: <Fallback height={408} /> }
)

export const LoadableRecentlyViewedCardWmo = loadable(
  () => import('../RecentViewedProduct/RecentlyViewedCardWmo'),
  { fallback: <Fallback height={408} /> }
)

export default RecentlyViewCard
